module.exports = __webpack_public_path__ + "static/media/PartyTotalsSocial.80ffffef.jpg";